/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_English_Studies19Inputs */

const en__field_enum_study_english_studies19 = /** @type {(inputs: _Field_Enum_Study_English_Studies19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English Studies`)
};

const de__field_enum_study_english_studies19 = /** @type {(inputs: _Field_Enum_Study_English_Studies19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`English Studies`)
};

/**
* | output |
* | --- |
* | "English Studies" |
*
* @param {_Field_Enum_Study_English_Studies19Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_english_studies19 = /** @type {((inputs?: _Field_Enum_Study_English_Studies19Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_English_Studies19Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_english_studies19(inputs)
	return de__field_enum_study_english_studies19(inputs)
});
export { _field_enum_study_english_studies19 as "_field_enum_STUDY_ENGLISH_STUDIES" }